import React, { useRef } from "react";

import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

import { theme } from "../../theme";
// import clsx from "clsx";
import EventSourceSelector, {
  flowType,
} from "./EventSourceSelector/EventSourceSelector";
// import ConnectionForm from "./ConnectionForm/ConnectionForm";
// import LoadingConnection from "./LoadingConnection/LoadingConnection";
// import ProviderEvents from "./ProviderEvents/ProviderEvents";
// import importedEvents from "../CreateEventFlow/providerEvents.json";
import ImportedDataList from "./ImportedDataList/ImportedDataList";
import NewEventDetails from "./NewEventDetails/NewEventDetails";
import { useAuthenticated } from "react-admin";
import { dataType } from "../../components/GenericList/GenericList";
import CSVMappingForm from "../EventSessions/CSVUploadFlow/CSVMappingForm";
import { createEventFlow as classes} from "./styles";


export interface csvData {
  data: any[];
  file: File | null;
}



const ColorlibStepIcon = (props: any) => {
  const { active, completed } = props;

  const icons: { [index: string]: React.ReactElement } = {
    1: <span>01</span>,
    2: <span>02</span>,
    3: <span>03</span>,
    4: <span>04</span>,
  };

  return (
    <Box
    sx={{
      zIndex: 1,
      width: 30,
      height: 30,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "14px",

      color: active || completed ?  "#fff" : theme.palette.grey["800"],
      backgroundColor: active ? "#7BB325" : completed ? theme.palette.primary.dark : "#fff",
      filter: active ?  "drop-shadow(0px 2px 5px rgba(120, 120, 120, 0.5))" : '',
    }}
      // sx={clsx( {
      //   [classes.active]: active,
      //   [classes.completed]: completed,
      // })}
    >
      {icons[String(props.icon)]}
    </Box>
  );
};

const CreateEventFlow = () => {
  useAuthenticated();
 
  const [activeStep, setActiveStep] = React.useState(0);
  // const [providerEvents, setProviderEvents] = React.useState<any[]>([]);
  const [attendees, setAttendees] = React.useState<csvData>({
    data: [],
    file: null,
  });
  const [initialMap, setInitialMap] = React.useState();
  const [eventFlowType, setEventFlowType] = React.useState<string>();
  const sourceSelectorRef = useRef<any>();

  const getSteps = () => {
    return ["Select provider", "Map data", "Review data", "Create event"];
  };

  const handleNextStep = (step?: number) => {
    setActiveStep((prevActiveStep) =>
      typeof step === "number" ? step : prevActiveStep + 1
    );
  };

  const onProviderSelect = ({ type }: { type: string }) => {
    setEventFlowType(type);

    if (type === flowType.CSV_EVENT) {
      handleNextStep();
    }

    if (type === flowType.CUSTOM_EVENT) {
      handleNextStep(3);
    }
  };

  // const onSyncEvents = () => {
  //   handleNextStep();
  // };

  // const onDataLoaded = () => {
  //   setProviderEvents(importedEvents);
  // };

  // const onSelectEvent = (event: any) => {
  //   handleNextStep();
  // };

  const onValidateAttendees = () => {
    handleNextStep();
  };

  const onFileUpload = (data: any, fileInfo: any, file: File) => {
    setAttendees({ data, file });
    setEventFlowType(flowType.CSV_EVENT);
    handleNextStep(1);
  };

  // const resetFlow = () => {
  //   setAttendees({ data: [], file: null });
  //   handleNextStep(0);
  // };

  const steps = getSteps();

  return (
  <>
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          sx={classes.wrapper}
        >
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            sx={classes.wizardSteps}
          >
            {activeStep !== 0 && // we don't show the steps before selecting a flow
              steps
                .filter(
                  (label, index) =>
                    (eventFlowType === flowType.CUSTOM_EVENT && index < 2) || // there are different number of steps for different flows
                    eventFlowType === flowType.CSV_EVENT
                )
                .map((label, index) => (
                  <Step key={label}>
                    <StepLabel StepIconComponent={ColorlibStepIcon}></StepLabel>
                  </Step>
                ))}
          </Stepper>

          {activeStep === 0 && (
            <EventSourceSelector
              ref={sourceSelectorRef}
              providerSelect={onProviderSelect}
              fileUpload={onFileUpload}
            />
          )}
          {activeStep === 1 && (
            <CSVMappingForm
              initialMap={initialMap}
              csvType={dataType.ATTENDEES}
              csvData={attendees.data}
              onFormSubmit={(mapValues: any) => {
                setInitialMap(mapValues);
                handleNextStep(2);
              }}
              onCancel={() => {
                handleNextStep(0);
                // sourceSelectorRef.current?.openCSVWarning(); this is not working because the component is rendered dynamically
              }}
            />
          )}
          {activeStep === 2 && (
            <ImportedDataList
              csvFieldsMatch={initialMap}
              csvType={dataType.ATTENDEES}
              csvData={attendees.data}
              onValidateData={onValidateAttendees}
              onRejectData={() => {
                handleNextStep(1);
              }}
            />
          )}
          {activeStep === 3 && (
            <NewEventDetails
              issueButtonClick={() => {
                if(eventFlowType === flowType.CUSTOM_EVENT)
                  handleNextStep(0);
                else
                  handleNextStep(2);
              }}
              attachedAttendees={attendees}
              csvFieldsMatch={initialMap}
            />
          )}

          {/* {activeStep === 1 && <ConnectionForm syncEvents={onSyncEvents} />}
          {activeStep === 2 && providerEvents.length === 0 && (
            <LoadingConnection dataLoaded={onDataLoaded} />
          )}
          {activeStep === 2 && providerEvents.length > 0 && (
            <ProviderEvents events={providerEvents} selectEvent={onSelectEvent} />
          )} */}
        </Box>
        </>
  );
};

export default CreateEventFlow;
